<template>
  <template
    v-if="props.disabled || allowed"
  >
    <slot />
  </template>
</template>

<script setup lang="ts">
import type { UserRole } from '~/composables/charon'

const props = defineProps<{
  roles?: UserRole[]
  team?: boolean
  disabled?: boolean
}>()

const me = useMe()

const allowed = computed(() => {
  const hasRoles = !props.roles || (me.value?.roles && props.roles.some(r => me.value!.roles!.includes(r)))
  const isTeam = !props.team || me.value?.team
  return hasRoles && isTeam
})
</script>
